'use client';

import { useEffect } from 'react';

// Silent registration only — no install prompts, banners, or UI. Phase 2
// (push notifications) will register a second worker (firebase-messaging-sw.js)
// alongside this one.
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
  }, []);

  return null;
}
